/*=========================================================================================
  File Name: module-internal-state.js
  Description: Internal Module State
  ----------------------------------------------------------------------------------------
  Project: MISA Internal
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {};
